import React from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, FormControlLabel, Radio, RadioGroup, FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";

const CustomRadioBox = ({
  name,
  label,
  control,
  options = [],
  errors,
  disabled,
  row = true, // default: radio buttons in a row
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <FormGroup>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <RadioGroup {...field} row={row} onChange={(e) => field.onChange(e.target.value)}>
              {options.map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<Radio disabled={disabled} />}
                  label={t(option.label)}
                />
              ))}
            </RadioGroup>
            {errors[name] && <FormHelperText error>{errors[name]?.message}</FormHelperText>}
          </>
        )}
      />
    </FormGroup>
  );
};

export default React.memo(CustomRadioBox);
